import requestLanguageList from '@/api/language';

const state = {
  languageList: null,
};

const getters = {
  languageList: (state) => state.languageList,
};

const actions = {
  async setLanguageList({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestLanguageList();
    commit('setLanguageList', result);
    await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  setLanguageList(state, languageList) {
    state.languageList = languageList.data.list;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
